import React, { useEffect, useState } from "react";
import {
  LinearProgress,
  Card,
  CardContent,
  Typography,
  IconButton,
  Fab,
} from "@mui/material";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import "./DragAndDrop.scss";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useTranslation } from "react-i18next";

const DragAndDrop = ({
  id,
  file,
  onFileChange,
  onFileRemove,
  uploadProgress,
  onUploadProgress,
  handleDrop,
}) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      onFileChange(selectedFile);
    }
  };

  const handleRemoveFile = () => {
    onFileRemove();
  };

  const handleUploadProgress = (event) => {
    const progress = Math.round((event.loaded / event.total) * 100);
    onUploadProgress(id, progress);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          clearInterval(timer);
          return 100;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {!file && (
        <section className="drag-drop" style={{ margin: "5px 0px" }}>
          <div
            className={`document-uploader upload-box`}
            onDrop={handleDrop}
            onDragOver={(event) => event.preventDefault()}
          >
            <div className="upload-info">
              <BackupOutlinedIcon />
            </div>
            <div>
              <p>
                {t("Draganddrop")}
                <span>
                  <input
                    type="file"
                    hidden
                    id={`browse-${id}`}
                    onChange={handleFileChange}
                    onProgress={handleUploadProgress}
                    accept=".pdf"
                  />
                  <label htmlFor={`browse-${id}`} className="browse-btn">
                    {t("orChoosefile")}
                  </label>
                </span>
              </p>
            </div>
          </div>
        </section>
      )}
      {file && (
        <div className="file-list">
          <div className="file-list__container">
            <Card className="file-item">
              <CardContent display="flex" sx={{ width: "100%" }} size="large">
                <Fab color="disabled">
                  <DescriptionOutlinedIcon />
                </Fab>
                <Typography variant="span">
                  {file.name ? file.name : file}
                </Typography>
                {progress < 100 ? (
                  <span></span>
                ) : (
                  <span>
                    <CheckCircleIcon color="primary" />
                  </span>
                )}
                <IconButton sx={{ float: "right" }} onClick={handleRemoveFile}>
                  {progress < 100 ? (
                    <ClearIcon />
                  ) : (
                    <DeleteOutlineOutlinedIcon />
                  )}
                </IconButton>
              </CardContent>
            </Card>
          </div>
          <LinearProgress variant="determinate" value={progress} />
        </div>
      )}
    </>
  );
};

export default DragAndDrop;
